export const dateUTC = (planDate: string) => {
  const date = new Date(planDate);
  const formatter = new Intl.DateTimeFormat("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "UTC",
  });
  const created = planDate
    ? planDate.includes("T")
      ? formatter.format(date).replace(",", "")
      : planDate
    : "";
  return created;
};
